<template>
  <div>
    <v-dialog v-model="dialog" fullscreen lazy>
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>{{ course.name ? course.name : $tc('course') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn @click="close()" dark icon>
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider/>
        <v-card-text>
          <v-container fluid>
            <v-layout wrap>
              <v-flex xs12 v-html="course.content"></v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close()" color="primary" small>{{$t('cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'DialogCourse',
  props: {
    dialog: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapState({
      selected: state => state.courses.selected
    }),
    course () {
      if (!this.selected) return {}
      let course = {}
      course.name = this.getName(this.selected.name)
      course.content = this.getName(this.selected.content)
      return course
    }
  },
  methods: {
    close () {
      this.$emit('update:dialog', false)
    }
  }
}
</script>
